import { MarkerContainer, getContrastText } from '@kinetic-ui/shared';
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

const HTML_CACHE: { [key: string]: string } = {};

const CLUSTER_MARKER_WIDTH = 23;
const CLUSTER_MARKER_HEIGHT = 23;
const CLUSTER_MARKER_COLOR = 'black';

const DEFAULT_MAP_MARKER_WIDTH = 25;
const DEFAULT_MAP_MARKER_HEIGHT = 25;

const LEGEND_MARKER_COLOR = 'black';

const getMarkerPath = (color?: string) => (
  <path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V4ZM15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19Z'
    fill={color}
  />
);

export const clusterMarker = renderToStaticMarkup(
  <svg
    width={CLUSTER_MARKER_WIDTH}
    height={CLUSTER_MARKER_HEIGHT}
    viewBox='0 0 22 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform='translate(-0.5 0) scale(0.9)'>{getMarkerPath(CLUSTER_MARKER_COLOR)}</g>
  </svg>
);

export const LegendMarker: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} fontSize={'medium'} viewBox='0 0 22 26'>
    <g transform='translate(-5.7 0) scale(0.9)'>{getMarkerPath(LEGEND_MARKER_COLOR)}</g>
  </SvgIcon>
);

export const MapSearchResultMarker: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} fontSize={'large'} viewBox='0 0 22 26'>
    <g transform='translate(-3.2 -0.3) scale(1.15)'>{getMarkerPath()}</g>
  </SvgIcon>
);

const getDefaultMapMarker = (color: string, width: number, height: number) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 22 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.485 21.663H2C1.46957 21.663 0.960859 21.4523 0.585786 21.0773C0.210714 20.7022 0 20.1935 0 19.663V1.99805C0 1.46761 0.210714 0.958906 0.585786 0.583833C0.960859 0.208761 1.46957 -0.00195312 2 -0.00195312L20 -0.00195312C20.5304 -0.00195312 21.0391 0.208761 21.4142 0.583833C21.7893 0.958906 22 1.46761 22 1.99805V19.663C22 20.1935 21.7893 20.7022 21.4142 21.0773C21.0391 21.4523 20.5304 21.663 20 21.663H13.513L11 25.998L8.485 21.663Z'
        fill={color}
      />
      <g transform='scale(0.9)'>{getMarkerPath(getContrastText(color))}</g>
    </svg>
  );
};

export const getRampMeterMarkerMarkup = (
  color: string,
  customIcon: React.ReactNode,
  customIconName: string | null
) => {
  const cacheString = customIconName || color;
  const cache = HTML_CACHE[cacheString];

  if (cache) {
    return cache;
  }

  let markup;

  if (customIcon) {
    markup = renderToStaticMarkup(
      <MarkerContainer color={color}>
        <svg xmlns='http://www.w3.org/2000/svg' height='20px' viewBox='1 1 22 20' width='22px'>
          {customIcon}
        </svg>
      </MarkerContainer>
    );
  } else {
    markup = renderToStaticMarkup(
      getDefaultMapMarker(color, DEFAULT_MAP_MARKER_WIDTH, DEFAULT_MAP_MARKER_HEIGHT)
    );
  }

  HTML_CACHE[cacheString] = markup;
  return markup;
};
